import React, { useState, useEffect } from "react";
import { Box, Button, Heading, Text } from "grommet";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import API_URL from "../../config/config";

const EditProfile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get("error");
  const message = params.get("message");

  // useEffect(() => {
  //   // Fetch user information from the backend
  //   axios
  //     .get(`${API_URL}/auth/user`)
  //     .then((response) => {
  //       setUser(response.data.user);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching user:", error);
  //       // Redirect to login if not authenticated
  //       window.location.href = "/login";
  //     });
  // }, []);

  const handleEditProfile = () => {
    // Navigate to the /auth/profile endpoint to initiate the profile edit flow
    window.location.href = `${API_URL}/auth/profile`;
  };

  if (!user) {
    return <div>Loading...</div>;
  }
  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box pad="medium" gap="medium" flex>
          <Heading level="2">Your Profile</Heading>

          {error && <Text color="status-critical">{error}</Text>}
          {message && <Text color="status-ok">{message}</Text>}

          <Box>
            <Text>
              <strong>Name:</strong> {user.idTokenClaims.name}
            </Text>
            <Text>
              <strong>Email:</strong>{" "}
              {user.idTokenClaims.emails && user.idTokenClaims.emails[0]}
            </Text>
            {/* Add other profile fields as needed */}
          </Box>

          <Button
            label="Edit Profile"
            primary
            onClick={handleEditProfile}
            size="medium"
          />
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default EditProfile;
